import React, { Fragment, useContext } from 'react';
import './Profile.scss';

import bannerBackground from './AssetsProfile/bannerPhoto.png';
import profilePhoto from './AssetsProfile/fisherPhoto.png';
import marketerPhoto from './AssetsProfile/marketerPhoot.svg';
import organizationPhoto from './AssetsProfile/organizationPhoto.svg';
import uploadProduct from './AssetsProfile/uploadProduct.svg';
import { useState } from 'react';
import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { uiContext } from '../common';
import {API} from '../../services/api';

import regionDataJson from '../../assets/regiones.json';

const Profile = () => {
    /**
     * Vista del perfil del usuario
     * Se carga la informacion del usuario por medio del sessionToken
     * Una vez cargada la información es renderizada en el formulario.
     * Se puede actualizar la información
     * Se puede actualizar la foto de perfil
     */
    const history = useHistory();
    const uicontext = useContext(uiContext);
    const [profileType, SetProfileType] = useState("FISHER");

    const [name, setName] = useState('');
    const [lastname, setLastname] = useState('');
    const [rut, setRut] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [mobilePhone, setMobilePhone] = useState('');
    const [comment, setComment] = useState('');
    const [type, setType] = useState('');
    const [typeKey, setTypeKey] = useState("");
    const [approvalState, setApprovalState] = useState("");
    const [approvalStateDescription, setApprovalStateDescription] = useState("");
    const [regionKey, setRegionKey] = useState("");
    const [cityKey, setCityKey] = useState("");
    const [communeKey, setCommuneKey] = useState("");
    const [sectorKey, setSectorKey] = useState("");
    const [website, setWebsite] = useState("");
    const [message, setMessage] = useState("");
    const [photoUrl, setPhotoUrl] = useState("");
    const [coverUrl, setCoverUrl] = useState("");
    const [birthDate, setBirthDate] = useState("");

    const [businessLine, setBusinessLine] = useState("");
    const [businessLegalName, setBusinessLegalName] = useState("");

    const [regionSelect, setRegionSelect] = useState([]);
    const [citySelect, setCitySelect] = useState([]);
    const [communeSelect, setCommuneSelect] = useState([]);

    const [termsAccepted, setTermsAccepted] = useState(true);

    const [personalDeliveryEnabled, setPersonalDeliveryEnabled] = useState(false);
    const [deliveryEnabled, setDeliveryEnabled] = useState(false);

    const updateProfilePhoto = () => {
        let input = document.createElement('input');
        input.type = 'file';
        input.accept = '.webp,.png,.jpg,.jpeg,.svg';
        input.click();
        input.onchange = () => {
            uicontext.showLoader();
            if (!input.files.length) {
                alert("File too big");
                this.loader.hide();
                uicontext.hideLoader();
                return;
            }
            var file = input.files[0];
            var fileType = file.type.split('/')[0];
            if (file.size > 50 * 1000 * 1000) {
                this.loader.hide();
                alert("File too big");
                uicontext.hideLoader();
                return;
            }

            /**
             * Subir archivo
             * Se hace el llamado al servicio /uploads/
             */
            API.postUploadFile(file)
                .then(x => {
                    const url = `${uicontext.API}/images/${x.filename}`;
                    setPhotoUrl(url);
                    let sessionToken = localStorage.getItem("sessionToken");
                    if (sessionToken !== null) {
                        uicontext.showLoader();
                        let dataToUpdate = {
                            sessionKey: sessionToken,
                            name: name,
                            lastname: lastname,
                            rut: rut,
                            email: email,
                            phone: phone,
                            mobilePhone: mobilePhone,
                            comment: comment,
                            type: type,
                            typeKey: typeKey,
                            regionKey: regionKey,
                            cityKey: cityKey,
                            communeKey: communeKey,
                            sectorKey: sectorKey,
                            website: website,
                            message: message,
                            photoUrl: url,
                            coverUrl: coverUrl,
                            birthDate: birthDate,
                            businessLegalName: businessLegalName,
                            businessLine: businessLine,
                            personalDeliveryEnabled: (personalDeliveryEnabled === "true" || personalDeliveryEnabled === true),
                            deliveryEnabled: (deliveryEnabled === "true" || deliveryEnabled === true),
                            termsAccepted: true
                        };

                        uicontext.showLoader();
                        API.putUpdateUserData(dataToUpdate)
                            .then(x => {
                                setTermsAccepted(true);
                                uicontext.hideLoader();
                            })
                            .catch(x => {
                                uicontext.hideLoader();
                            });
                    }
                })
                .catch(x => {
                    uicontext.hideLoader();
                })
        }
    }

    const updateBannerPhoto = () => {
        let input = document.createElement('input');
        input.type = 'file';
        input.accept = '.webp,.png,.jpg,.jpeg,.svg';
        input.click();
        input.onchange = () => {
            uicontext.showLoader();
            if (!input.files.length) {
                alert("File too big");
                this.loader.hide();
                uicontext.hideLoader();
                return;
            }
            var file = input.files[0];
            var fileType = file.type.split('/')[0];
            if (file.size > 50 * 1024 * 1024) {
                this.loader.hide();
                alert("File too big");
                uicontext.hideLoader();
                return;
            }

            /**
             * Subir archivo
             * Se hace el llamado al servicio /uploads/
             */
            API.postUploadFile(file)
                .then(x => {
                    const url = `${uicontext.API}/images/${x.filename}`;
                    setCoverUrl(url);
                    let sessionToken = localStorage.getItem("sessionToken");
                    if (sessionToken !== null) {
                        uicontext.showLoader();
                        let dataToUpdate = {
                            sessionKey: sessionToken,
                            name: name,
                            lastname: lastname,
                            rut: rut,
                            email: email,
                            phone: phone,
                            mobilePhone: mobilePhone,
                            comment: comment,
                            type: type,
                            typeKey: typeKey,
                            regionKey: regionKey,
                            cityKey: cityKey,
                            communeKey: communeKey,
                            sectorKey: sectorKey,
                            website: website,
                            message: message,
                            photoUrl: photoUrl,
                            coverUrl: url,
                            birthDate: birthDate,
                            businessLegalName: businessLegalName,
                            businessLine: businessLine,
                            personalDeliveryEnabled: (personalDeliveryEnabled === "true" || personalDeliveryEnabled === true),
                            deliveryEnabled: (deliveryEnabled === "true" || deliveryEnabled === true),
                            termsAccepted: true
                        };

                        uicontext.showLoader();
                        API.putUpdateUserData(dataToUpdate)
                            .then(x => {
                                setTermsAccepted(true);
                                uicontext.hideLoader();
                            })
                            .catch(x => {
                                uicontext.hideLoader();
                            });
                    }
                })
                .catch(x => {
                    uicontext.hideLoader();
                })
        }
    }

    const acceptTerms = () => {
        let sessionToken = localStorage.getItem("sessionToken");
        if (sessionToken !== null) {
            let dataToUpdate = {
                sessionKey: sessionToken,
                name: name,
                lastname: lastname,
                rut: rut,
                email: email,
                phone: phone,
                mobilePhone: mobilePhone,
                comment: comment,
                type: type,
                typeKey: typeKey,
                regionKey: regionKey,
                cityKey: cityKey,
                communeKey: communeKey,
                sectorKey: sectorKey,
                website: website,
                message: message,
                photoUrl: photoUrl,
                coverUrl: coverUrl,
                birthDate: birthDate,
                businessLegalName: businessLegalName,
                businessLine: businessLine,
                personalDeliveryEnabled: (personalDeliveryEnabled === "true" || personalDeliveryEnabled === true),
                deliveryEnabled: (deliveryEnabled === "true" || deliveryEnabled === true),
                termsAccepted: true
            };

            uicontext.showLoader();
            /**
             * Actualizar datos del usuario
             * Se hace le llamado al servicio /users/update-user-data
             */
            API.putUpdateUserData(dataToUpdate)
                .then(x => {
                    setTermsAccepted(true);
                    uicontext.hideLoader();
                })
                .catch(x => {
                    uicontext.hideLoader();
                });
        }
    }

    useEffect(() => {
        //FISHER
        //MARKETER
        //ORGANIZATION
        const sessionKey = localStorage.getItem("sessionToken");
        uicontext.showLoader();
        
        /**
         * Consultar los datos del usuario por el token
         * Se hace le llamado al servicio /users/get-user-by-session-key
         */
        API.putUserBySessionKey(sessionKey)
            .then(response =>{
                uicontext.setLogin(true);
                uicontext.setName(response.name !== null ? response.name : "");
                setName(response.name !== null ? response.name : "");
                setLastname(response.lastname !== null ? response.lastname : "");
                setRut(response.rut !== null ? response.rut : "");
                setEmail(response.email !== null ? response.email : "");
                setPhone(response.phone !== null ? response.phone : "");
                setMobilePhone(response.mobilePhone !== null ? response.mobilePhone : "");
                setComment(response.comment !== null ? response.comment : "");
                setType(response.type !== null ? response.type : "");
                setTypeKey(response.typeKey !== null ? response.typeKey : "");
                setApprovalState(response.approvalState !== null ? response.approvalState : "");
                setApprovalStateDescription(response.approvalStateDescription !== null ? response.approvalStateDescription : "");
                setRegionKey(response.regionKey !== null ? response.regionKey : regionDataJson[0].region);
                setCityKey(response.cityKey !== null ? response.cityKey : regionDataJson[0].provincias[0].name);
                setCommuneKey(response.communeKey !== null ? response.communeKey : regionDataJson[0].provincias[0].comunas[0].name);
                setSectorKey(response.sectorKey !== null ? response.sectorKey : "");
                setWebsite(response.website !== null ? response.website : "");
                setMessage(response.message !== null ? response.message : "");
                setPhotoUrl(response.photoUrl !== null ? response.photoUrl : "");
                setCoverUrl(response.coverUrl !== null ? response.coverUrl : "");
                SetProfileType(response.type !== null && response.type !== "" ? response.type : "FISHER");
                setBusinessLine(response.businessLine !== null ? response.businessLine : "");
                setBusinessLegalName(response.businessLegalName !== null ? response.businessLegalName : "");
                setBirthDate(response.birthDate !== null ? response.birthDate : "");
                setPersonalDeliveryEnabled(response.personalDeliveryEnabled !== null ? response.personalDeliveryEnabled : false);
                setDeliveryEnabled(response.deliveryEnabled !== null ? response.deliveryEnabled : false);
                setTermsAccepted(response.termsAccepted !== null ? response.termsAccepted : false)
                uicontext.hideLoader();
            })
            .catch(x => {
                uicontext.hideLoader();
                history.push("/login");
            })
        
    }, []);

    const updateUserData = () => {
        let sessionToken = localStorage.getItem("sessionToken");
        if (sessionToken !== null) {
            uicontext.showLoader();
            let dataToUpdate = {
                sessionKey: sessionToken,
                name: name,
                lastname: lastname,
                rut: rut,
                email: email,
                phone: phone,
                mobilePhone: mobilePhone,
                comment: comment,
                type: type,
                typeKey: typeKey,
                regionKey: regionKey,
                cityKey: cityKey,
                communeKey: communeKey,
                sectorKey: sectorKey,
                website: website,
                message: message,
                photoUrl: photoUrl,
                coverUrl: coverUrl,
                birthDate: birthDate,
                businessLegalName: businessLegalName,
                businessLine: businessLine,
                personalDeliveryEnabled: (personalDeliveryEnabled === "true" || personalDeliveryEnabled === true),
                deliveryEnabled: (deliveryEnabled === "true" || deliveryEnabled === true),
                termsAccepted: true
            };

            uicontext.showLoader();
            API.putUpdateUserData(dataToUpdate)
                .then(x => {
                    setTermsAccepted(true);
                    uicontext.hideLoader();
                })
                .catch(x => {
                    uicontext.hideLoader();
                });
        }
    }

    const getUserTypeDefaultPhoto = () => {
        switch (type) {
            case "FISHER": return profilePhoto;
            case "MARKETER": return marketerPhoto;
            case "ORGANIZATION": return organizationPhoto;
            default:
                return profilePhoto;
        }
    }

    const getUserTypeDefaultBanner = () => {
        switch (type) {
            case "FISHER": return bannerBackground;
            case "MARKETER": return bannerBackground;
            case "ORGANIZATION": return bannerBackground;
            default:
                return bannerBackground;
        }
    }


    useEffect(() => {
        let regionOptions = [];
        for (let i = 0; i < regionDataJson.length; i++) {
            regionOptions.push(<option value={regionDataJson[i].region} key={regionDataJson[i].region}>{regionDataJson[i].region}</option>);
        }
        setRegionSelect(regionOptions);

        let cityOptions = [];
        for (let i = 0; i < regionDataJson.length; i++) {
            if (regionDataJson[i].region === regionKey) {
                for (let j = 0; j < regionDataJson[i].provincias.length; j++) {
                    cityOptions.push(<option value={regionDataJson[i].provincias[j].name} key={regionDataJson[i].provincias[j].name}>{regionDataJson[i].provincias[j].name}</option>);
                }
            }
        }
        setCitySelect(cityOptions);

        let communeOptions = [];
        for (let i = 0; i < regionDataJson.length; i++) {
            if (regionDataJson[i].region === regionKey) {
                for (let j = 0; j < regionDataJson[i].provincias.length; j++) {
                    if (regionDataJson[i].provincias[j].name === cityKey) {
                        for (let k = 0; k < regionDataJson[i].provincias[j].comunas.length; k++) {
                            communeOptions.push(<option value={regionDataJson[i].provincias[j].comunas[k].name} key={regionDataJson[i].provincias[j].comunas[k].code}>{regionDataJson[i].provincias[j].comunas[k].name}</option>);
                        }
                    }
                }
            }
        }
        setCommuneSelect(communeOptions);
    }, [regionKey, cityKey]);

    const setCityAndCommuneZero = (value) => {
        for (let i = 0; i < regionDataJson.length; i++) {
            if (regionDataJson[i].region === value) {
                setCityKey(regionDataJson[i].provincias[0].name);
                setCommuneKey(regionDataJson[i].provincias[0].comunas[0].name);
            }
        }
    }

    const setCommuneToZero = (value) => {
        for (let i = 0; i < regionDataJson.length; i++) {
            if (regionDataJson[i].region === regionKey) {
                for (let j = 0; j < regionDataJson[i].provincias.length; j++) {
                    if (regionDataJson[i].provincias[j].name === value) {
                        setCommuneKey(regionDataJson[i].provincias[j].comunas[0].name);
                    }
                }
            }
        }
    }

    return (
        <div className="ProfileMasterContainer">
            <div className="subContainer">

                <div className="headerGrid">
                    <div className="profileBanner">
                        <img src={(coverUrl === null || coverUrl === "") ? getUserTypeDefaultBanner() : coverUrl} alt="" />
                    </div>

                    <button onClick={() => { updateBannerPhoto() }} className="uploadButtonBase uploadBackgroundPhotoButton">Subir portada</button>

                    <div className="profilePhoto">
                        <img src={(photoUrl === null || photoUrl === "") ? getUserTypeDefaultPhoto() : photoUrl} alt="" />
                    </div>

                    <button onClick={() => { updateProfilePhoto() }} className="uploadButtonBase uploadProfilePhotoButton">Subir foto perfil</button>
                </div>

                <div className={(termsAccepted === true ? "formContentDisabled" : "") + " termsSection"}>
                    <span className="termsTitle">Declaración de acuerdos</span>
                    <span className="termsContent">
                        Por el presente instrumento yo ({name + " " + lastname}) me comprometo a cumplir con las
                        <a href="http://www.sernapesca.cl/sites/default/files/manual_bbpp_version_final_0.pdf" target="_blank"> recomendaciones y buenas prácticas </a>que forman parte del programa Caleta en línea, así como colaborar en el cuidado y comercialización responsable del producto.
                    </span>
                    {termsAccepted === false && <button onClick={() => { acceptTerms(); }} className="acceptTermsButton">Aceptar</button>}
                </div>

                <form className={(termsAccepted === false ? "formContentDisabled" : "") + " formContent"} onSubmit={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    updateUserData();
                }}>
                    <div className="personalData">
                        <span className="formTitle">
                            Datos personales
                        </span>
                        
                        {profileType === "FISHER" &&
                            <Fragment>
                                <div className="formField">
                                    <span>Nombre</span>
                                    <input required value={name} onChange={(event) => { setName(event.target.value); }} className="input50" type="text" />
                                </div>
                                <div className="formField">
                                    <span>Apellido</span>
                                    <input required value={lastname} onChange={(event) => { setLastname(event.target.value); }} className="input50" type="text" />
                                </div>
                                <div className="formField">
                                    <span>Fecha de nacimiento</span>
                                    <input required value={birthDate} onChange={(event) => { setBirthDate(event.target.value); }} className="input50" type="date" />
                                </div>
                                <div className="formField">
                                    <span>Tipo de cuenta</span>
                                    <input value={type} onChange={(event) => { setType(event.target.value); }} disabled className="input50" type="text" />
                                </div>
                                <div className="formField">
                                    <span>Registro de Pescador Artesanal</span>
                                    <input required value={typeKey} onChange={(event) => { setTypeKey(event.target.value); }} className="input50" type="text" />
                                </div>
                                <div className="formField">
                                    <span className="notranslate">Rut</span>
                                    <input required value={rut} onChange={(event) => { setRut(event.target.value); }} className="input50" type="text" />
                                </div>
                            </Fragment>}

                        {profileType === "MARKETER" &&
                            <Fragment>
                                <div className="formField">
                                    <span>Razón social</span>
                                    <input required={profileType === "MARKETER"} value={businessLegalName} onChange={(event) => { setBusinessLegalName(event.target.value); }} className="input50" type="text" />
                                </div>
                                <div className="formField">
                                    <span>Giro</span>
                                    <input required={profileType === "MARKETER"} value={businessLine} onChange={(event) => { setBusinessLine(event.target.value); }} className="input50" type="text" />
                                </div>
                                <div className="formField">
                                    <span className="notranslate">Rut</span>
                                    <input required value={rut} onChange={(event) => { setRut(event.target.value); }} className="input50" type="text" />
                                </div>
                                <div className="formField">
                                    <span>Tipo de cuenta</span>
                                    <input required value={type} onChange={(event) => { setType(event.target.value); }}  disabled className="input50" type="text" />
                                </div>
                                <div className="formField">
                                    <span>Número de registro Sernapesca</span>
                                    <input required value={typeKey} onChange={(event) => { setTypeKey(event.target.value); }} className="input50" type="text" />
                                </div>
                            </Fragment>}

                        {profileType === "ORGANIZATION" &&
                            <Fragment>
                                <div className="formField">
                                    <span>Razón social</span>
                                    <input required={profileType === "ORGANIZATION"} value={businessLegalName} onChange={(event) => { setBusinessLegalName(event.target.value); }} className="input50" type="text" />
                                </div>
                                <div className="formField">
                                    <span>Nombre</span>
                                    <input required value={name} onChange={(event) => { setName(event.target.value); }} className="input50" type="text" />
                                </div>
                                <div className="formField">
                                    <span>Apellido</span>
                                    <input required value={lastname} onChange={(event) => { setLastname(event.target.value); }} className="input50" type="text" />
                                </div>
                                <div className="formField">
                                    <span className="notranslate">RUT</span>
                                    <input required value={rut} onChange={(event) => { setRut(event.target.value); }} className="input50" type="text" />
                                </div>
                                <div className="formField">
                                    <span>Tipo de cuenta</span>
                                    <input value={type} onChange={(event) => { setType(event.target.value); }} disabled className="input50" type="text" />
                                </div>
                                <div className="formField">
                                    <span>Número de ROA</span>
                                    <input required value={typeKey} onChange={(event) => { setTypeKey(event.target.value); }} className="input50" type="text" />
                                </div>
                            </Fragment>}
                    </div>

                    <div className="selectGender">

                    </div>

                    <div className="addressData">
                        <span className="formTitle">
                            Residencia
                        </span>

                        <div className="formField">
                            <span>Región</span>
                            <select className="input50 customSelect" required value={regionKey} onChange={(event) => { setRegionKey(event.target.value); setCityAndCommuneZero(event.target.value); }}>
                                {regionSelect}
                            </select>
                        </div>
                        <div className="formField">
                            <span>Provincias</span>
                            <select className="input50 customSelect" required value={cityKey} onChange={(event) => { setCityKey(event.target.value); setCommuneToZero(event.target.value); }}>
                                {citySelect}
                            </select>
                        </div>
                        <div className="formField">
                            <span>Comuna</span>
                            <select className="input50 customSelect" required value={communeKey} onChange={(event) => { setCommuneKey(event.target.value); }}>
                                {communeSelect}
                            </select>
                        </div>
                        <div className="formField">
                            <span>Caleta</span>
                            <input required value={sectorKey} onChange={(event) => { setSectorKey(event.target.value); }} className="input50" type="text" />
                        </div>
                    </div>

                    <div className="contactData">
                        <span className="formTitle">
                            Datos de contacto
                        </span>

                        <div className="formField">
                            <span>Celular</span>
                            <input value={mobilePhone} onChange={(event) => { setMobilePhone(event.target.value); }} className="input50" type="text" />
                        </div>
                        <div className="formField">
                            <span>Teléfono</span>
                            <input value={phone} onChange={(event) => { setPhone(event.target.value); }} className="input50" type="text" />
                        </div>
                        <div className="formField">
                            <span>Correo electrónico</span>
                            <input value={email} disabled onChange={(event) => { setEmail(event.target.value); }} className="input50" type="text" />
                        </div>
                        <div className="formField">
                            <span>Sitio web</span>
                            <input value={website} onChange={(event) => { setWebsite(event.target.value); }} className="input50" type="text" />
                        </div>
                        <div className="formField">
                            <span>¿Se pueden retirar los productos en caleta?</span>
                            <select className="input50 customSelect" value={personalDeliveryEnabled} onChange={(event) => { setPersonalDeliveryEnabled(event.target.value); }}>
                                <option value={true}>Si</option>
                                <option value={false}>No</option>
                            </select>
                        </div>

                        <div className="formField">
                            <span>¿Tiene despacho a domicilio?</span>
                            <select className="input50 customSelect" value={deliveryEnabled} onChange={(event) => { setDeliveryEnabled(event.target.value); }}>
                                <option value={true}>Si</option>
                                <option value={false}>No</option>
                            </select>
                        </div>
                    </div>

                    <div className="fisherMessage">
                        <span className="formTitle">
                            Mensaje del pescador
                        </span>

                        <div className="formField formField100">
                            <textarea value={message} onChange={(event) => { setMessage(event.target.value); }} className="messageTextArea"></textarea>
                        </div>

                        <input type="submit" className="updateButton" value="Actualizar"></input>
                    </div>

                    <div className="uploadFishings">
                        <span className="formTitle">
                            Sube tus pescados y/o mariscos
                        </span>

                        <div onClick={() => { history.push("/new-product") }} className="uploadFishingsContainer">
                            <img src={uploadProduct} alt="" />
                            <div className="textContent">
                                <span>Sube tus</span>
                                <span>productos aquí</span>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    )
}

export default Profile;